export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const FETCH_POINTS = 'FETCH_POINTS';
export const FETCH_TAGS = 'FETCH_TAGS';
export const ADD_POINT_OF_INTEREST = 'ADD_POINT_OF_INTEREST';
export const EDIT_POINT_OF_INTEREST = 'EDIT_POINT_OF_INTEREST';
export const UPLOAD_POINTS_OF_INTEREST = 'UPLOAD_POINTS_OF_INTEREST';
export const FETCH_POI_ICONS = 'FETCH_POI_ICONS';
